<template>
  <Toast type="info-primary" icon="iconoir-info-empty">
    <template #title>{{ $t('userPasswordChangedToast.title') }}</template>
    <span>{{ $t('userPasswordChangedToast.content') }}</span>
  </Toast>
</template>

<script>
import Toast from './Toast.vue'
import { TOAST_AUTO_DISMISS_MS } from '@baserow/modules/core/utils/toastConstants'

export default {
  name: 'UserPasswordChangedToast',
  components: {
    Toast,
  },
  mounted() {
    // Was a bare 7000ms literal; see `UserSessionExpiredToast`.
    this.acknowledgeTimeout = setTimeout(() => {
      this.acknowledgeTimeout = null
      this.acknowledge()
    }, TOAST_AUTO_DISMISS_MS)
  },
  beforeUnmount() {
    if (this.acknowledgeTimeout) {
      clearTimeout(this.acknowledgeTimeout)
      this.acknowledgeTimeout = null
    }
    this.acknowledge()
  },
  methods: {
    acknowledge() {
      this.$store.dispatch('toast/setUserPasswordChanged', false)
    },
  },
}
</script>
